var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaptopFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 6C14.0207 6 13.3212 6.28973 12.8055 6.80546C12.2897 7.32118 12 8.02065 12 8.75V19.75C12 20.4793 12.2897 21.1788 12.8055 21.6945C13.3212 22.2103 14.0207 22.5 14.75 22.5H21.25C21.9793 22.5 22.6788 22.2103 23.1945 21.6945C23.7103 21.1788 24 20.4793 24 19.75V12.75C24 12.5511 23.921 12.3603 23.7803 12.2197L17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H14.75ZM13.8661 7.86612C14.1005 7.6317 14.4185 7.5 14.75 7.5H16.5V12.75C16.5 13.1642 16.8358 13.5 17.25 13.5H22.5V19.75C22.5 20.0815 22.3683 20.3994 22.1339 20.6339C21.8995 20.8683 21.5815 21 21.25 21H14.75C14.4185 21 14.1005 20.8683 13.8661 20.6339C13.6317 20.3994 13.5 20.0815 13.5 19.75V8.75C13.5 8.41848 13.6317 8.10054 13.8661 7.86612ZM21.4393 12L18 8.56066V12H21.4393Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5C4.34315 1.5 3 2.84315 3 4.5V12H4.5V4.5C4.5 3.67157 5.17157 3 6 3H15C15.8284 3 16.5 3.67157 16.5 4.5H18C18 2.84315 16.6569 1.5 15 1.5H6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H10.5V13.5H1.5C1.5 14.3284 2.17157 15 3 15H10.5V16.5H3C1.34315 16.5 0 15.1569 0 13.5V12Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaptopFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop-file.6081c1de97a150dfed15a0e416488eb6.svg";